<template>
  <div>
    <v-tabs
      v-if="llds && systemSettings && options && siteInfo"
      data-testId="tabs"
      fixed-tabs
      color="dover-blue"
      slider-color="yellow"
      dark
      icons-and-text
      show-arrows>
      <v-tab
        v-for="lld in llds"
        :data-testId="`tab-lld-`+`${ lld.lldNumber }`"
        :key="lld.lldNumber"
        :href="'#tab-' + lld.lldNumber"
        ripple>
        {{ lld.lldNumber }} - {{ lld.lldDescription }}
        <v-icon>mdi-database</v-icon>
      </v-tab>
      <v-tab-item
        v-for="lld in llds"
        :key="lld.lldNumber"
        :value="'tab-' + lld.lldNumber">
        <MaglinkLineLeakConfigGroup
          :data-testId="`MaglinkLineLeakConfigGroup-`+`${ lld.lldNumber }`"
          :is-new-lld="false"
          :lld="lld"
          :llds="llds"
          :system-settings="systemSettings"
          :site-info="siteInfo"
          :options="options"
          :component-key="componentKey"
          :tanks="tanks"
          :sensors="sensors"
          @lldSaved="onLldSaved"
          @lldDeleted="onLldDeleted"/>
      </v-tab-item>
      <v-tab
        v-if="totalTanks > totalLlds"
        :key="0"
        :href="'#tab-0'"
        data-testId="tab-0"
        ripple>
        <v-icon>mdi-plus</v-icon>
      </v-tab>
      <v-tab-item
        :key="0"
        :value="'tab-0'">
        <MaglinkLineLeakConfigGroup
          :is-new-lld="true"
          :system-settings="systemSettings"
          :site-info="siteInfo"
          :options="options"
          :tanks="tanks"
          :sensors="sensors"
          :llds="llds"
          data-testId="MaglinkLineLeakConfigGroup-0"
          @lldSaved="onLldSaved"/>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>

import { i18n } from '@/i18n'

export default {
  data: () => ({
    llds: undefined,
    systemSettings: undefined,
    siteInfo: undefined,
    options: undefined,
    componentKey: 0,
    tanks: undefined,
    sensors: undefined,
    totalLlds: 0,
    totalTanks: 1
  }),
  mounted () {
    // CHECK PERMISSION
    // *******************************************************************
    this.Maglink.CheckPermission()
    // *******************************************************************

    this.Maglink.GetOptions()
      .then(response => {
        this.Maglink.TranslateOptionNames(response)
        this.options = { ...this.options, ...response.data }
      })
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetSettings('SiteInfo')
      .then(response => (this.siteInfo = { ...this.siteInfo, ...response.data }))
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetSettings('SystemSettings')
      .then(response => (this.systemSettings = { ...this.systemSettings, ...response.data }))
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetTanksHeaders()
      .then(response => {
        this.tanks = response.data
        this.totalTanks = this.tanks.length
      })
      .catch(error => (this.snack('error', error.message)))

    this.Maglink.GetSensors()
      .then(response => {
        this.sensors = response.data
      })
      .catch(error => (this.snack('error', error.message)))

    this.getLlds()
  },
  methods: {
    findLld (lld) {
      for (var i = 0; i < this.llds.length; i++) {
        if (this.llds[i].lldNumber === lld.lldNumber &&
            this.llds[i].tankNumber === lld.tankNumber) {
          return i
        }
      }

      return -1
    },
    getLlds () {
      this.Maglink.GetLlds()
        .then(response => {
          this.llds = response.data
          this.totalLlds = this.llds.length
        })
        .catch(error => (this.snack('error', error.message)))
    },
    onLldSaved (lld) {
      if (this.findLld(lld) === -1) {
        this.getLlds()
      }
    },
    onLldDeleted (lld) {
      if (this.findLld(lld) !== -1) {
        this.getLlds()
      }
    },
    snack (color, message) {
      message = i18n.t('Line leak config') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
